export default __webpack_public_path__ + "static/char-s-18-jp-aec1780fc476623f3fc246e905f84cf1.webp";